import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Компонент PrivacyPolicyPage - страница "Политика конфиденциальности"
 */
const PrivacyPolicyPage = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
      {/* Фоновый узор */}
      <div className="fixed inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:20px_20px] opacity-20 pointer-events-none"></div>

      {/* Навигация */}
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

      {/* Контент */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl sm:text-5xl font-bold mb-6">Политика конфиденциальности</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">1. Общие положения</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Добро пожаловать на Gensio! Мы уважаем вашу конфиденциальность и обязуемся защищать
            любые персональные данные, которые вы нам предоставляете. Данная политика описывает,
            какие данные мы собираем, как используем и защищаем их, а также какие у вас есть права.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">2. Сбор информации</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-2">
            Мы можем собирать следующую информацию:
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>Персональные данные: имя, email (когда вы отправляете форму обратной связи).</li>
            <li>Технические данные: IP-адрес, тип браузера, время доступа.</li>
            <li>Файлы cookie и аналогичные технологии для улучшения работы сайта.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">3. Использование данных</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Собранные данные используются для:
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>Обработки и ответа на ваши запросы.</li>
            <li>Анализа работы сайта и улучшения функционала.</li>
            <li>Обеспечения безопасности и предотвращения мошенничества.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">4. Передача данных третьим лицам</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Мы не передаем ваши персональные данные третьим лицам без вашего согласия,
            за исключением случаев, предусмотренных законодательством, или когда передача необходима
            для оказания услуг (например, хостинг-провайдеры).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">5. Файлы cookie</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Сайт использует cookie для хранения настроек: темы оформления, языковых предпочтений
            и аналитики. Вы можете в любой момент отключить cookie в настройках браузера.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">6. Безопасность</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Мы принимаем разумные технические и организационные меры для защиты данных от несанкционированного
            доступа, изменения или уничтожения.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-2">8. Связаться с нами</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Если у вас есть вопросы по политике конфиденциальности, напишите нам на
            email <a href="mailto:info@gensio.ru" className="text-indigo-600 dark:text-indigo-400">info@gensio.ru</a>.
          </p>
        </section>

        <p className="text-sm text-gray-500 dark:text-gray-600">
          Последнее обновление: 29 апреля 2025 г.
        </p>
      </main>

      {/* Футер */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
